import { memo } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

import { ANNOTATION_INDICATOR, COMMENT_METADATA_CONTAINER } from '~/constants/testIDs';
import { type IconType } from '~/types/icons';

export const discussionMetadata = tailwindVariants({
  base: 'mx-1 flex items-center gap-1 leading-none',
  variants: {
    color: {
      blue: 'ads:text-accent text-blue-9',
      grey: 'ads:text-metadata text-gray-9',
      teal: 'ads:text-ads-cyan-11 text-teal-9',
    },
  },
  defaultVariants: {
    color: 'grey',
  },
});

export type DiscussionMetadataProps = VariantProps<typeof discussionMetadata> & {
  Icon: IconType;
  text?: string;
  textTestId?: string;
};

export const DiscussionMetadata = memo(({ color, text, Icon, textTestId }: DiscussionMetadataProps) => {
  return (
    <div className={discussionMetadata({ color })} data-testid={COMMENT_METADATA_CONTAINER}>
      {!!Icon && <Icon data-testid={ANNOTATION_INDICATOR} size="xs" />}
      {!!text && (
        <div className="text-10 text-inherit" data-testid={textTestId}>
          {text}
        </div>
      )}
    </div>
  );
});

DiscussionMetadata.displayName = 'DiscussionAnnotationInfo';
